import type { cookies } from 'next/headers';

/**
 * 로그인 완료를 클라이언트에 알리는 1회성 마커.
 *
 * 로그인은 BFF 라우트에서 쿠키를 심고 307 로 끝나 클라이언트에 "방금 로그인했다" 는
 * 순간이 없다. GA `click_login` 발사와 완료 토스트 노출의 신호로 쓰며,
 * `LoginCompletionTracker` 가 읽는 즉시 삭제한다.
 *
 * - httpOnly=false: JS 가 읽어야 한다.
 * - 짧은 만료: 리다이렉트 직후 소비되지 않으면 의미가 없다.
 * - `setAuthCookies` 안에 두지 않는다 — 토큰 갱신(`/api/auth/refresh`)도 그 함수를 쓰기 때문에
 *   갱신이 로그인으로 집계돼버린다. 로그인 완료 라우트에서만 명시적으로 호출한다.
 */
export const LOGIN_EVENT_COOKIE_NAME = 'gtm_login';

const MAX_AGE_SECONDS = 60;

type CookieStore = Awaited<ReturnType<typeof cookies>>;

export function setLoginEventCookie(cookieStore: CookieStore) {
  cookieStore.set(LOGIN_EVENT_COOKIE_NAME, '1', {
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'lax',
    path: '/',
    httpOnly: false,
    maxAge: MAX_AGE_SECONDS,
  });
}

/** 클라이언트에서 소비 직후 호출 — 새로고침 중복 집계 방지. */
export function clearLoginEventCookie() {
  if (typeof document === 'undefined') return;
  document.cookie = `${LOGIN_EVENT_COOKIE_NAME}=; path=/; max-age=0; samesite=lax`;
}
